import { SVGCross as SVGCrossComponent } from "@/lib/svg";
import { resetButton } from "@/lib/styles";
import styled from "styled-components";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SVGCross = SVGCrossComponent as any;

export const Button = styled.button`
  ${resetButton}
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
  padding: 0 1rem;
  font-size: 1.25rem;
  height: 40px;
  border-radius: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
`;

export const Label = styled.span`
  transform: translateY(0.2188rem);
  line-height: 0.8;
  font-weight: 400;
`;

export const Icon = styled(SVGCross as any)`
  width: 1em;
`;

export const DarkButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
`;

export const LightButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border: solid 1px;
`;
